// @flow
import Enum from '@rover/react-lib/types/Enum';

let rootUrl = '';

if (process && process.env && process.env.WEBAPP_ROOT_URL) {
  rootUrl = process.env.WEBAPP_ROOT_URL.replace(/\/$/, ''); // strip the trailing slash if there is one
}

export class APIVersion extends Enum<string> {
  static v3 = new APIVersion('v3');
  static v4 = new APIVersion('v4');
}

export const frontendDefaultApiVersion = APIVersion.v3;

export const apiUrl = (suffix: string = '', version: string = frontendDefaultApiVersion) =>
  `/api/${version}/${suffix}`;

export const fullApiUrl = (suffix: string, version?: string) => {
  const path = apiUrl(suffix, version);

  // server side
  if (rootUrl) {
    return `${rootUrl}${path}`;
  }

  // client side
  return path;
};

export default {
  apiUrl,
  fullApiUrl,
  frontendDefaultApiVersion,
};



// WEBPACK FOOTER //
// ../utilities/apiUrl.js